import { render } from "./PasswordComplete.vue?vue&type=template&id=c027ff38&scoped=true"
import script from "./PasswordComplete.vue?vue&type=script&lang=js"
export * from "./PasswordComplete.vue?vue&type=script&lang=js"

import "./PasswordComplete.vue?vue&type=style&index=0&id=c027ff38&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c027ff38"]])

export default __exports__